export const formatDate = (date: string | Date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';

    return new Intl.DateTimeFormat(undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(d);
};

export const formatDateWithTime = (date: string | Date, timeZone?: string) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';

    const finalTimeZone = timeZone && timeZone !== 'UTC' ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;

    return new Intl.DateTimeFormat(undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: finalTimeZone,
        timeZoneName: 'short',
    }).format(d);
};

export const formatTime = (date: string | Date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';

    return new Intl.DateTimeFormat(undefined, {
        hour: '2-digit',
        minute: '2-digit',
    }).format(d);
};
